<template lang="pug">
div( 
    :class="$style.root" 
)
    MerchantLogo(
        :class="$style.merchant"
    )

</template>

<script lang="ts">
import Vue, { computed } from 'vue'

import { useAppStore } from '@/shared/model'

import MerchantLogo from './MerchantLogo.vue'

export default Vue.extend({
    name: 'Static',
    components: {
        MerchantLogo,
    },
    setup() {
        const { state, logoUrl } = useAppStore()
        const merchant = computed(() => state.merchant)

        return {
            merchant,
            logoUrl,
        }
    },
})
</script>

<style module lang="scss">
.root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.merchant {
    height: rem(28);
}
</style>
